import { chapterList } from "@/mocks/manga";

export default function Chapters() {
  return (
    <section id="chapters" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-sm font-medium tracking-wide text-primary-600">CHAPTER GUIDE</span>
            <h2 className="font-heading mt-2 text-3xl text-foreground-950 md:text-4xl">分话人物解析</h2>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-foreground-600">
              精选关键分话，逐话拆解人物行为动机与剧情转折，标注不容错过的名场面与伏笔。
            </p>
          </div>
          <span className="rounded-full bg-accent-100 px-4 py-1.5 text-sm text-accent-900">
            每话持续更新解析
          </span>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
          {chapterList.map((ch) => (
            <article
              key={ch.no}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 md:flex-row"
            >
              <div className="relative h-48 w-full shrink-0 overflow-hidden bg-background-200 md:h-auto md:w-2/5">
                <img
                  src={ch.img}
                  alt={`${ch.no} ${ch.title} 剧情场景`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-3 py-1 text-xs text-background-50 backdrop-blur">
                  {ch.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-lg text-foreground-950">{ch.title}</h3>
                  <span className="whitespace-nowrap text-sm text-foreground-500">{ch.no}</span>
                </div>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{ch.summary}</p>
                <div className="mt-4 inline-flex items-center gap-2 self-start rounded-md bg-secondary-100 px-3 py-1.5 text-sm text-secondary-900">
                  <i className="ri-star-fill text-accent-500" />
                  名场面 · {ch.highlight}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}